import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {GlobalAppData} from '../models/global-app-data';
import {PaypalService} from '../services/paypal.service';
import {PaypalResponse} from '../models/paypal';
import {SharedService} from '../services/shared.service';
import {environment} from '../../environments/environment';

import {MerchantResponseComponent} from '../merchant-response/merchant-response.component';
import {MerchantResponseData} from '../models/merchant-models';
import {LoadingService} from '../services/loading.service';
import {OrderService} from '../services/order.service';
import { SegmentService } from '../services/segment.service';
import { EventTypes } from '../models/enums/event-types';


declare var paypal;

@Component({
  selector: 'app-paypal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.css'],
  standalone: false
})
export class PaypalComponent implements OnInit {
  @ViewChild('paypal', { static: true }) paypalElement: ElementRef;
  MAX_ALLOWED_ATTEMPTS: number = environment.MAX_PAYMENT_ALLOWED_ATTEMPTS;
  paymentStatus: string;
  @ViewChild(MerchantResponseComponent) merchantResponseComponent;

  constructor(private gd: GlobalAppData,
    private paypalService: PaypalService,
    private sharedService: SharedService,
    private _loading: LoadingService,
    private odService: OrderService,
    private ss: SegmentService) { }

  ngOnInit(): void {
    paypal.Buttons({
      createOrder: (data, actions) => {
        this._loading.setLoading(true, 'internal');
        this.gd.paymentType = 'paypal';
        this.ss.track(EventTypes.ppSubmitted);
        return this.createPaypalOrder().then((orderId: string) => {
          this._loading.setLoading(false, 'internal');
          console.log('[paypal order ]',orderId)
          return orderId;
        }).catch((err) => {
          this.handlePaypalDecline(this.gd.attemptCount);
          return null;
        });
      },
      onApprove: () => {
        this._loading.setLoading(true, 'internal');
        this.ss.track(EventTypes.ppApproved);
        return this.paypalService.capturePaypalOrder(this.gd.transId)
          .then((res: PaypalResponse) => {
            if (res.status === 'COMPLETED') {
              this.redirectToMerchantSuccessURL();
            } else {
              this.handlePaypalDecline(this.gd.attemptCount);
            }
          })
          .catch((err) => {
            this.handlePaypalDecline(this.gd.attemptCount);
          });
      },
      onCancel: async (data, actions) => {
        this.ss.track(EventTypes.ppCancel);
        await this.sendTxRejectStatus();
        this.handlePaypalDecline(this.gd.attemptCount);
      },
      onError: err => {
        console.error(`paypal error `, err);
        if (err.toString() !== 'Error: Detected popup close') {
          console.error(`paypal on error`);
          this.ss.track(EventTypes.ppError);
          this.handlePaypalDecline(this.gd.attemptCount);
        }
      },
      style: {
        layout: 'vertical',
        label: 'paypal',
        color: 'white',
        shape: 'rect',
        size: 'responsive'
      }
    }).render(this.paypalElement.nativeElement);
  }

  getAmount(): number {
    return this.gd.orderTransaction.amount;
  }

  createPaypalOrder(): Promise<string> {
    return new Promise((resolve, reject) => {
      return this.paypalService.getPaypalOrderId(this.gd.transId)
        .then((ppRes: PaypalResponse) => {
          sessionStorage.setItem('page', this.gd.attemptCount.toLocaleString());
          resolve(ppRes.paypalOrderId);
        })
        .catch((err) => {
          reject(JSON.stringify(err));
        });
    });
  }

  handlePaypalDecline(pmtAttemptCount: number): void {
    this.paymentStatus = 'paymentError';
    if (pmtAttemptCount < this.MAX_ALLOWED_ATTEMPTS) {
      this.paymentStatus = 'declined';
      this.generateNewTransactionToRetry();
    } else {
      this.redirectToMerchantRejectURL();
    }
    this._loading.setLoading(false, 'internal');
  }

  redirectToMerchantSuccessURL(): void {
    let merchantSuccessURL = this.gd.orderTransaction.order.merchantSuccessURL;
    if (!merchantSuccessURL) {
      merchantSuccessURL = this.gd.oscConfig.successUrl;
    }
    this.redirectToMerchant(merchantSuccessURL);
  }

  redirectToMerchantRejectURL(): void {
    let merchantRejectURL = this.gd.orderTransaction.order.merchantRejectURL;
    if (!merchantRejectURL) {
      merchantRejectURL = this.gd.oscConfig.rejectUrl;
    }
    this.redirectToMerchant(merchantRejectURL);
  }

  sendTxRejectStatus(): Promise<void> {
    return this.odService.sendTxRejectStatus(this.gd.transId);
  }

  redirectToMerchant(urlVal: string): void {
    sessionStorage.clear()
    window.sessionStorage.clear()
    const paymentActionData = {
      url: urlVal,
      orderTransaction: this.gd.orderTransaction,
      merchantPaymentReq: {},
    } as MerchantResponseData;
    this.merchantResponseComponent.sendResponseToMerchant('PAYPAL', paymentActionData);
  }

  generateNewTransactionToRetry(): void {
    this.sharedService.getNewTransactionId(this.gd.transId)
      .then((res: string) => {
        this.gd.transId = res;
        this.gd.attemptCount++;
        sessionStorage.setItem('transId', res);  // keep for consistency
        console.log(`[PAYPAL_RETRY] New transId=${res} attemptCount=${this.gd.attemptCount}`);
      }).catch((error) => {
        if (error && error.status && error.error) {
          console.debug(`error paypal new txn attempt ${error?.error}`);
        }
      }).finally(() => {
        this._loading.setLoading(false, 'internal');
      });
  }
}
